<template>
  <v-data-table :headers="headers" :items="functions">
    <template v-slot:top>
      <FormDialog :dialog="create_dialog" :close="closeCreateDialog" :title="modal_title">
        <FormFunctions :editData="function_selected" :closeDialog="closeCreateDialog" />
      </FormDialog>
      <div class="d-flex justify-end">
        <v-btn color="green lighten-1" dark class="my-2" @click="openCreate">
          <v-icon class="mr-1">mdi-plus</v-icon>
          Criar</v-btn
        >
      </div>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
    </template>
  </v-data-table>
</template>

<script>
import { mapState } from 'vuex'
import FormDialog from '@/components/dialogs/FormDialog.vue'
import FormFunctions from './FormFunctions.vue'

export default {
  name: 'FunctionsList',
  components: { FormDialog, FormFunctions },
  data: () => {
    return {
      function_selected: {},
      create_dialog: false,
      headers: [
        { text: '#', value: 'id' },
        { text: 'Função', value: 'functions' },
        { text: 'Ações', value: 'actions' },
      ],
    }
  },
  computed: {
    ...mapState('utils', ['functions']),
    modal_title() {
      if (this.function_selected.functions) {
        return 'Editar Função'
      } else {
        return 'Cadastrar Função'
      }
    },
  },
  methods: {
    openCreate() {
      this.create_dialog = true
    },
    closeCreateDialog() {
      this.create_dialog = false
      this.function_selected = {}
    },
    editItem(data) {
      this.function_selected = data
      this.openCreate()
    },
  },
}
</script>
